import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-164628da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm-navbar mx-auto shadow position-fixed rounded-4 justify-content-center align-items-center bg-dark" }
const _hoisted_2 = { class: "d-flex p-0 mb-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator bg-success position-absolute rounded-circle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavLinkComponent = _resolveComponent("NavLinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_NavLinkComponent, {
        name: "welcome",
        title: "Главная",
        icon: "fas fa-home-alt"
      }),
      _createVNode(_component_NavLinkComponent, {
        name: "account",
        title: "Профиль",
        icon: "far fa-user"
      }),
      _createVNode(_component_NavLinkComponent, {
        name: "favorites",
        title: "Избранное",
        icon: "far fa-heart"
      }),
      _createVNode(_component_NavLinkComponent, {
        name: "notifications",
        title: "Уведомления",
        icon: "far fa-bell"
      }),
      _hoisted_3
    ])
  ]))
}